// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import { api } from '../../../../utility/constants'

// Generate Jobno
export const generateJobno = createAsyncThunk('JobCutting/generateJobno', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/generateJobCuttingNoJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/generateJobCuttingNo`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          JobNo: response1.data.body && response1.data.body.JobNo ? response1.data.body.JobNo : ''
        }
      } else {
        return {
          JobNo: response1.data.body ? response1.data.body.JobNo : ''
        }
      }
    } else {
      return {
        JobNo: response.data.body ? response.data.body.JobNo : ''
      }
    }
  } catch (error) {
    return {
      JobNo: ''
    }
  }
})

export const onChangeJobCuting = createAsyncThunk('JobCutting/onchangeJobCutting', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/onchangeJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/onchangeJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          designList: response1.data.body && response1.data.body.DesignList ? response1.data.body.DesignList : [],
          SubCategoryList: response1.data.body && response1.data.body.SubCategoryList ? response1.data.body.SubCategoryList : []

        }
      } else {
        return {
          designList: response1.data.body ? response1.data.body.DesignList : [],
          SubCategoryList: response1.data.body ? response1.data.body.SubCategoryList : []
        }
      }
    } else {
      return {
        designList: response.data.body ? response.data.body.DesignList : [],
        SubCategoryList: response.data.body ? response.data.body.SubCategoryList : []
      }
    }
  } catch (error) {
    return {
      designList: [],
      SubCategoryList: []
    }
  }
})

export const getSizeListData = createAsyncThunk('JobCutting/getSizeListData', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/getSizeForJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/getSizeForJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          SizeList: response1.data.body && response1.data.body.SizeList ? response1.data.body.SizeList : []
        }
      } else {
        return {
          SizeList: response1.data.body ? response1.data.body.SizeList : []
        }
      }
    } else {
      return {
        SizeList: response.data.body ? response.data.body.SizeList : []
      }
    }
  } catch (error) {
    return {
      SizeList: []
    }
  }
})

export const getItemListData = createAsyncThunk('JobCutting/getItemListData', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/getItemsForJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/getItemsForJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          ListItem: response1.data.body && response1.data.body.ItemList ? response1.data.body.ItemList : []
        }
      } else {
        return {
          ListItem: response1.data.body ? response1.data.body.ItemList : []
        }
      }
    } else {
      return {
        ListItem: response.data.body ? response.data.body.ItemList : []
      }
    }
  } catch (error) {
    return {
      ListItem: []
    }
  }
})

export const getTypeListData = createAsyncThunk('JobCutting/getTypeListData', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/getTypesForJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/getTypesForJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          TypeList: response1.data.body && response1.data.body.TypeList ? response1.data.body.TypeList : []
        }
      } else {
        return {
          TypeList: response1.data.body ? response1.data.body.TypeList : []
        }
      }
    } else {
      return {
        TypeList: response.data.body ? response.data.body.TypeList : []
      }
    }
  } catch (error) {
    return {
      TypeList: []
    }
  }
})
// Edit JobCutting LIST
export const editData = createAsyncThunk('JobCutting/editData', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/editJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/editJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          editJobCuttingArray: response1.data.body && response1.data.body.editJobCuttingArray ? response1.data.body.editJobCuttingArray : []
        }
      } else {
        return {
          editJobCuttingArray: response1.data.body ? response1.data.body.editJobCuttingArray : []
        }
      }
    } else {
      return {
        editJobCuttingArray: response.data.body ? response.data.body.editJobCuttingArray : []
      }
    }
  } catch (error) {
    return {
      editJobCuttingArray: []
    }
  }
})

//saveData Api
export const saveData = createAsyncThunk('JobCutting/saveData', async params => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/saveJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/saveJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          statusFlag: response1.data.body && response1.data.body.statusFlag ? response1.data.body.statusFlag : 2,
          message: response1.data.body.message,
          saveJobData: response1.data.body.resultData
        }
      } else {
        return {
          statusFlag: response1.data.body ? response1.data.body.statusFlag : 2,
          message: response1.data.body ? response1.data.body.message : 'Server not reachable.Please try again later',
          saveJobData: response1.data.body ? response1.data.body.resultData : {}
        }
      }
    } else {
      return {
        statusFlag: response.data.body ? response.data.body.statusFlag : 2,
        message: response.data.body ? response.data.body.message : 'Server not reachable.Please try again later',
        saveJobData: response.data.body ? response.data.body.resultData : {}
      }
    }
  } catch (error) {
    return {
      statusFlag: 2,
      message: 'Server not reachable.Please try again later',
      saveJobData: {}
    }
  }
})

export const JobCuttinglist = createAsyncThunk('JobCutting/getJobCuttinglist', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/jobcuttingListJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/jobcuttingList`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          JobCuttinglist: response1.data.body && response1.data.body.JobCuttingArray ? response1.data.body.JobCuttingArray : [],
          CompanyList: response1.data.body && response1.data.body.CompanyArray ? response1.data.body.CompanyArray : [],
          TotalJobCutting: response1.data.body && response1.data.body.TotalData ? response1.data.body.TotalData : []
        }
      } else {
        return {
          JobCuttinglist: response1.data.body ? response1.data.body.JobCuttingArray : [],
          CompanyList: response1.data.body ? response1.data.body.CompanyArray : [],
          TotalJobCutting: response1.data.body ? response1.data.body.TotalData : []
        }
      }
    } else {
      return {
        JobCuttinglist: response.data.body ? response.data.body.JobCuttingArray : [],
        CompanyList: response.data.body ? response.data.body.CompanyArray : [],
        TotalJobCutting: response.data.body ? response.data.body.TotalData : []
      }
    }
  } catch (error) {
    return {
      JobCuttinglist: [],
      CompanyList: [],
      TotalJobCutting: []
    }
  }
})

//DELETE JOB CUTTING
export const deleteData = createAsyncThunk('JobCutting/deleteData', async params => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/deleteJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/deleteJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          statusFlag: response1.data.body && response1.data.body.statusFlag ? response1.data.body.statusFlag : 2,
          message: response1.data.body.message
        }
      } else {
        return {
          statusFlag: response1.data.body ? response1.data.body.statusFlag : 2,
          message: response1.data.body ? response1.data.body.message : 'Server not reachable.Please try again later'
        }
      }
    } else {
      return {
        statusFlag: response.data.body ? response.data.body.statusFlag : 2,
        message: response.data.body ? response.data.body.message : 'Server not reachable.Please try again later'
      }
    }
  } catch (error) {
    return {
      statusFlag: 2,
      message: 'Server not reachable.Please try again later'
    }
  }
})

export const printJobCuttingData = createAsyncThunk('JobCutting/printJobCuttingData', async (params) => {
  try {
    const response = await axios.post(`${api.api_url}/production/jobcutting/printJobCuttingJwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params['jwtToken'] = response.data.body.token
      const response1 = await axios.post(`${api.api_url}/production/jobcutting/printJobCutting`, params)
      if (response1 && response1.data && response1.data.body) {
        return {
          Print_JobCutting_Array: response1.data.body && response1.data.body.PrintJobCuttingArray ? response1.data.body.PrintJobCuttingArray : [],
          Print_Company_Array: response1.data.body && response1.data.body.PrintCompanyArray ? response1.data.body.PrintCompanyArray : [],
          print_result: 'true'
        }
      } else {
        return {
          Print_JobCutting_Array: response1.data.body ? response1.data.body.PrintJobCuttingArray : [],
          Print_Company_Array: response1.data.body ? response1.data.body.PrintCompanyArray : [],
          print_result: 'false'
        }
      }
    } else {
      return {
        Print_JobCutting_Array: response.data.body ? response.data.body.PrintJobCuttingArray : [],
        Print_Company_Array: response.data.body ? response.data.body.PrintCompanyArray : [],
        print_result: 'false'
      }
    }
  } catch (error) {
    return {
      Print_JobCutting_Array: [],
      Print_Company_Array: [],
      print_result: 'false'
    }
  }
})

//  GET Common LIST
export const commonData = createAsyncThunk('JobCutting/commonData', async (params) => {
  const response = await axios.post(`${api.api_url}/production/jobcutting/fetchFilterDataJwt`, params)
  if (response && response.data && response.data.body && response.data.body.token) {
    params['jwtToken'] = response.data.body.token
    const response1 = await axios.post(`${api.api_url}/production/jobcutting/fetchFilterData`, params)
    if (response1 && response1.data && response1.data.body) {
      return {
        params,
        EmployeeArray: response1.data.body.EmployeeArray,
        // ItemArray: response1.data.body.ItemArray,   
        allsettypeArray: response1.data.body.allsettypeArray,
        allitemgroupArray: response1.data.body.allitemgroupArray,
        alldesignArray: response1.data.body.alldesignArray
      }
    } else {
    }
  }
})

// Machine Wise Employee search
export const onchangemachineemployeeData = createAsyncThunk('JobCutting/onchangemachineemployeeData', async params => {
  const response = await axios.post(`${api.api_url}/common/onchangeMachineEmployeeDataJwt`, params)
  if (response && response.data && response.data.body && response.data.body.token) {
    params = { jwtToken: response.data.body.token }
    const response1 = await axios.post(`${api.api_url}/common/onchangeMachineEmployeeData`, params)
    if (response1 && response1.data && response1.data.body) {
      return {
        MachineEmployeeList: response1.data.body.MachineEmployeeList
      }
    } else {
    }
  }
}
)

// Machine search
export const onchangemachineData = createAsyncThunk('JobCutting/onchangemachineData', async params => {
  const response = await axios.post(`${api.api_url}/common/onchangeMachineDataJwt`, params)
  if (response && response.data && response.data.body && response.data.body.token) {
    params = { jwtToken: response.data.body.token }
    const response1 = await axios.post(`${api.api_url}/common/onchangeMachineData`, params)
    if (response1 && response1.data && response1.data.body) {
      return {
        ListMachine: response1.data.body.MachineList
      }
    } else {
    }
  }
}
)

//saveData Rate
export const saveRateData = createAsyncThunk('JobCutting/saveRateData', async params => {
  try {
  const response = await axios.post(`${api.api_url}/production/jobcutting/updateRateJobCuttingJwt`, params)
   if (response && response.data && response.data.body && response.data.body.token) {
   params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/production/jobcutting/updateRateJobCutting`, params)
   if (response1 && response1.data && response1.data.body) {
    return {
      rateStatusFlag:response1.data.body && response1.data.body.statusFlag ? response1.data.body.statusFlag : 2,
      rateMessage: response1.data.body.message 
    }
   } else {
    return {
      rateStatusFlag: response1.data.body ? response1.data.body.statusFlag : 2,
      rateMessage: response1.data.body ? response1.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } else {
    return {
      rateStatusFlag: response.data.body ? response.data.body.statusFlag : 2,
      rateMessage: response.data.body ? response.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } catch (error) {
    return {
      rateStatusFlag:2,
      rateMessage:'Server not reachable.Please try again later'      
    }    
  }
})


export const getBrandList = createAsyncThunk('JobCutting/brandFilterListJwt', async params => {
  try {
  const response = await axios.post(`${api.api_url}/common/brandFilterListJwt`, params)
   if (response && response.data && response.data.body && response.data.body.token) {
   params['jwtToken'] = response.data.body.token
   const response1 = await axios.post(`${api.api_url}/common/brandFilterList`, params)
   if (response1 && response1.data && response1.data.body) {
    return {
      brand_List:response1.data.body && response1.data.body.BrandArray ? response1.data.body.BrandArray : [],
      all_Brand_List: response1.data.body && response1.data.body.All_Brand_Array ? response1.data.body.All_Brand_Array : [],
      brand_List_Message:response1.data.body.message
    }
   } else {
    return {
      brand_List:response1.data.body ? response1.data.body.BrandArray : [],
      all_Brand_List: response1.data.body ? response1.data.body.All_Brand_Array : [],
      brand_List_Message:response1.data.body ? response1.data.body.message : 'Server not reachable.Please try again later'
    }
   }  
  } else {
    return {
      brand_List:response.data.body ? response.data.body.BrandArray : [],
      all_Brand_List: response.data.body ? response.data.body.All_Brand_Array : [],
      brand_List_Message: response.data.body ? response.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } catch (error) {
    return {
      brand_List: [],
      all_Brand_List: [],
      brand_List_Message:'Server not reachable.Please try again later'
    }
  }
})

//getItemCategoryBasedOnBrand Api
export const getItemCategoryBasedOnBrand = createAsyncThunk('JobCutting/getItemCategoryBasedOnBrandJwt', async params => {
  const response = await axios.post(`${api.api_url}/orderManagement/itemManagement/getItemCategoryBasedOnBrandJwt`, params)
   if (response && response.data && response.data.body && response.data.body.token) {
   params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/orderManagement/itemManagement/getItemCategoryBasedOnBrand`, params)
   if (response1 && response1.data && response1.data.body) {
    return {
      ItemArray:response1.data.body.DefItemArray
    }
   } 
  } else {
    return {
      ItemArray: []
    }
   }
})

export const JobCuttingSlice = createSlice({
  name: 'JobCutting',
  initialState: {
    data: [],
    total: 1,
    params: {},
    designList: [],
    SubCategoryList: [],
    JobNo: '',
    SizeList: [],
    ListItem: [],
    TypeList: [],
    JobCuttinglist: [],
    editJobCuttingArray: [],
    allData: [],
    CompanyList: [],
    TotalJobCutting: {},
    statuslist: [],
    statusFlag: 0,
    saveJobData: {},
    statuscode: 0,    
    EmployeeArray: [],
    ItemArray: [],
    ListDesign: [],
    ListMachine: [],
    ListEmployee: [],
    allsettypeArray: [],
    allitemgroupArray: [],
    alldesignArray: [],
    MachineEmployeeList: [],
    jobId: '',
    rateStatusFlag: 0,
    rateMessage: '',
    brand_List: [],
    all_Brand_List: [],
    brand_List_Message:''
  },
  reducers: {
    handleStatusFlag: (state, action) => {
      state.statusFlag = action.payload.statusFlag
    },
    handleRateStatusFlag: (state, action) => {
      state.rateStatusFlag = action.payload.rateStatusFlag
    },
    clearstoreData: (state, action) => {
      state.JobNo = action.payload.JobNo
      state.designList = action.payload.designList
      state.SubCategoryList = action.payload.SubCategoryList
      state.SizeList = action.payload.SizeList
      state.ListItem = action.payload.ListItem
      state.TypeList = action.payload.TypeList
      state.editJobCuttingArray = action.payload.editJobCuttingArray
      state.Print_JobCutting_Array = action.payload.Print_JobCutting_Array
      state.Print_Company_Array = action.payload.Print_Company_Array
      state.print_result = action.payload.print_result     
      state.EmployeeArray = action.payload.EmployeeArray
      state.ListSize = action.payload.ListSize
      state.MachineEmployeeList = action.payload.MachineEmployeeList
      state.ListMachine = action.payload.ListMachine
      state.ItemArray = action.payload.ItemArray
      state.JobCuttinglist = action.payload.JobCuttinglist
      state.CompanyList = action.payload.CompanyList
      state.TotalJobCutting = action.payload.TotalJobCutting

    },
    handlepage: (state, action) => {
      state.jobId = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(generateJobno.fulfilled, (state, action) => {
      state.JobNo = action.payload.JobNo
    })
      .addCase(onChangeJobCuting.fulfilled, (state, action) => {
        state.designList = action.payload.designList
        state.SubCategoryList = action.payload.SubCategoryList
      })
      .addCase(getSizeListData.fulfilled, (state, action) => {
        state.SizeList = action.payload.SizeList
      })
      .addCase(getItemListData.fulfilled, (state, action) => {
        state.ListItem = action.payload.ListItem
      })
      .addCase(getTypeListData.fulfilled, (state, action) => {
        state.TypeList = action.payload.TypeList
      })
      .addCase(saveData.fulfilled, (state, action) => {
        state.statusFlag = action.payload.statusFlag
        state.message = action.payload.message
        state.saveJobData = action.payload.saveJobData
      })
      .addCase(JobCuttinglist.fulfilled, (state, action) => {
        state.JobCuttinglist = action.payload.JobCuttinglist
        state.CompanyList = action.payload.CompanyList
        state.TotalJobCutting = action.payload.TotalJobCutting
        state.params = action.payload.params
      })
      .addCase(editData.fulfilled, (state, action) => {
        state.editJobCuttingArray = action.payload.editJobCuttingArray
        state.params = action.payload.params
      })
      .addCase(deleteData.fulfilled, (state, action) => {
        state.message = action.payload.message
        state.statusFlag = action.payload.statusFlag
      })
      .addCase(printJobCuttingData.fulfilled, (state, action) => {
        state.Print_JobCutting_Array = action.payload.Print_JobCutting_Array
        state.Print_Company_Array = action.payload.Print_Company_Array
        state.print_result = action.payload.print_result
      })

      .addCase(commonData.fulfilled, (state, action) => {       
        state.EmployeeArray = action.payload.EmployeeArray
        // state.ItemArray = action.payload.ItemArray
        state.allsettypeArray = action.payload.allsettypeArray
        state.allitemgroupArray = action.payload.allitemgroupArray
        state.alldesignArray = action.payload.alldesignArray
        state.params = action.payload.params
      })
      .addCase(onchangemachineemployeeData.fulfilled, (state, action) => {
        state.MachineEmployeeList = action.payload.MachineEmployeeList
      })
      .addCase(onchangemachineData.fulfilled, (state, action) => {
        state.ListMachine = action.payload.ListMachine
      })
      .addCase(saveRateData.fulfilled, (state, action) => {
        state.rateStatusFlag = action.payload.rateStatusFlag
        state.rateMessage = action.payload.rateMessage
      })
      .addCase(getBrandList.fulfilled, (state, action) => {
        state.brand_List = action.payload.brand_List
        state.brand_List_Message = action.payload.brand_List_Message
        state.all_Brand_List = action.payload.all_Brand_List
      })
      .addCase(getItemCategoryBasedOnBrand.fulfilled, (state, action) => {
        console.log(action.payload.ItemArray, "action.payload.ItemArray")
        state.ItemArray = action.payload.ItemArray
      })
  }
})
export const {
  handleStatusFlag, clearstoreData, handlepage, handleRateStatusFlag
} = JobCuttingSlice.actions
export default JobCuttingSlice.reducer
